import { Button } from 'antd';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const TAB_ACTIONS_SLOT_ID = 'destination-editor-tab-actions';
const ActiveTabContext = createContext('basicInfo');

type DestinationEditorTabActionsProviderProps = Readonly<{
    activeTab: string;
    children: React.ReactNode;
}>;

export function DestinationEditorTabActionsProvider({ activeTab, children }: DestinationEditorTabActionsProviderProps) {
    return <ActiveTabContext.Provider value={activeTab}>{children}</ActiveTabContext.Provider>;
}

export function DestinationEditorTabActionsSlot() {
    return <div id={TAB_ACTIONS_SLOT_ID} />;
}

type DestinationEditorTabActionsProps = Readonly<{
    tabKey: string;
    saveLabel: string;
    isSaving: boolean;
    isSaveDisabled: boolean;
    onCancel: () => void;
    onSave: () => void;
}>;

export function DestinationEditorTabActions({
    tabKey,
    saveLabel,
    isSaving,
    isSaveDisabled,
    onCancel,
    onSave,
}: DestinationEditorTabActionsProps) {
    const activeTab = useContext(ActiveTabContext);
    const [slot, setSlot] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setSlot(document.getElementById(TAB_ACTIONS_SLOT_ID));
    }, []);

    if (!slot || activeTab !== tabKey) {
        return null;
    }

    return createPortal(
        <div className='destination-editor-tab-actions'>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type='primary' loading={isSaving} disabled={isSaveDisabled} onClick={onSave}>
                {saveLabel}
            </Button>
        </div>,
        slot
    );
}
